import AuthUser from './AuthUser';
import { useState } from 'react';

export default function Login() {
    const { http, setToken } = AuthUser();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const submitForm = async () => {
        try {
            const res = await http.post('/login', { email, password });
            setToken(res.data.user, res.data.access_token); // Save token
        } catch (error) {
            if (error.response) {
                if (error.response.status === 401) {
                    alert("❌ Wrong credentials! Please try again."); // Show alert for wrong credentials
                } else {
                    alert(`⚠️ Error: ${error.response.data.message || "Something went wrong"}`);
                }
            } else {
                alert("⚠️ Network Error: Please check your internet connection.");
            }
        }
    };

    return (
        <div className='row justify-content-center pt-5'>
            <div className='col-sm-6'>
                <div className='card p-4'>
                    <h4>Login Here...</h4>
                    <div className="form-group">
                        <label htmlFor="email">Email address:</label>
                        <input 
                            type="email" 
                            className="form-control" 
                            placeholder="Enter email" 
                            onChange={e => setEmail(e.target.value)} 
                            id="email" 
                        />
                    </div>
                    <div className="form-group mt-3">
                        <label htmlFor="pwd">Password:</label>
                        <input 
                            type="password" 
                            className="form-control" 
                            placeholder="Enter password" 
                            onChange={e => setPassword(e.target.value)} 
                            id="pwd" 
                        />
                    </div>
                    <div>
                        
                    <button type="button" className="btn btn-primary mt-4" onClick={submitForm}>
                        Login
                    </button> </div><div>
                    <a href='/create'>Register Here ...</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
